import { motion } from 'framer-motion';
import { ArrowRight, ExternalLink, Layers3 } from 'lucide-react';
import { Link } from 'react-router-dom';

const PlatformsSection = () => {
  return (
    <section id="platforms" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center mb-14">
          <span className="inline-flex items-center py-1 px-3 rounded-full bg-primary-100 text-primary-600 text-sm font-medium mb-4">
            <Layers3 size={16} className="mr-2" />
            Platforms
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-5">Software Platforms Within ACSE Capital</h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            ACSE Capital builds, acquires, and supports software platforms aligned with its AI SaaS and online business
            focus. estateTT is the flagship platform currently featured here.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="flex justify-center mb-6">
            <img
              src="/estatett-logo.webp"
              alt="estateTT logo"
              className="h-14 md:h-16 w-auto object-contain"
            />
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6 }}
            className="rounded-3xl border border-gray-100 bg-white shadow-xl overflow-hidden"
          >
            <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr]">
              <div className="p-8 md:p-10">
                <div className="inline-flex items-center rounded-full bg-primary-50 px-3 py-1 text-sm font-medium text-primary-600 mb-5">
                  Flagship Platform
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">estateTT</h3>
                <p className="text-lg text-gray-600 leading-relaxed mb-8">
                  ACSE Capital Inc.'s flagship Caribbean real estate technology platform for property search, listing
                  management, professional visibility, international user access, role-based workflows, and embedded
                  estateTT AI support.
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <Link
                    to="/platforms/estatett"
                    className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-primary-600 text-white font-medium hover:bg-primary-700 transition-colors"
                  >
                    View Platform
                    <ArrowRight size={18} className="ml-2" />
                  </Link>
                  <a
                    href="https://www.estatett.com"
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center justify-center px-6 py-3 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-colors"
                  >
                    Visit estateTT.com
                    <ExternalLink size={18} className="ml-2" />
                  </a>
                </div>
              </div>

              <div className="bg-gradient-to-br from-primary-600 via-primary-500 to-sky-500 p-8 md:p-10 text-white flex flex-col justify-center">
                <h4 className="text-2xl font-bold mb-4">
                  Caribbean real estate technology with embedded workflow intelligence.
                </h4>
                <p className="text-primary-50 leading-relaxed">
                  estateTT is being built for Caribbean property activity while remaining accessible to regional and
                  international users, including U.S.-based buyers, property owners, professionals, and businesses
                  interested in Caribbean real estate markets.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PlatformsSection;
